export const BOOTSTRAP_USERS = 'BOOTSTRAP_USERS'
export const SET_SELECTED_USERS = 'SET_SELECTED_USERS'
export const SET_TOTAL_USERS = 'SET_TOTAL_USERS'
export const RESET_SELECTED_USER = 'RESET_SELECTED_USER'
export const SET_SELECT_ALL_STATE = 'SET_SELECT_ALL_STATE'
export const VIEW_USER = 'VIEW_USER'
export const ADD_USER = 'ADD_USER'
export const UPDATE_USER = 'UPDATE_USER'